var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5596 20.3712C11.8891 20.6985 12.4234 20.6985 12.7529 20.3712C13.0824 20.0439 13.0824 19.5133 12.7529 19.186L6.03699 12.6167L12.7529 6.04742C13.0824 5.72012 13.0824 5.18947 12.7529 4.86217C12.4234 4.53487 11.8891 4.53487 11.5596 4.86217L4.24713 12.0241C3.91762 12.3514 3.91762 12.882 4.24713 13.2093L11.5596 20.3712Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5596 20.3712C18.8891 20.6985 19.4234 20.6985 19.7529 20.3712C20.0824 20.0439 20.0824 19.5133 19.7529 19.186L13.037 12.6167L19.7529 6.04742C20.0824 5.72012 20.0824 5.18947 19.7529 4.86217C19.4234 4.53487 18.8891 4.53487 18.5596 4.86217L11.2471 12.0241C10.9176 12.3514 10.9176 12.882 11.2471 13.2093L18.5596 20.3712Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleChevronLeft);
export default __webpack_public_path__ + "static/media/double-chevron-left.3c2ccdf4.svg";
export { ForwardRef as ReactComponent };